const editorsPicksSlider = new Swiper('.blog__editors-picks__slider', {
  loop: false,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
})

const mobileNav = document.querySelector('.blog__secondary-nav__mobile')
const ac = document.querySelector('.blog-ac')
const arrow = document.getElementById('drop-down-arrow')

mobileNav.addEventListener('click', () => {
  if (!ac.style.animation || ac.style.animation.includes('slideout')) {
    mobileNav.style.borderBottom = '1px solid #B8C89F'
    arrow.style.transform = 'rotate(180deg)'
    ac.style.animation = 'slidein 1s forwards'
  } else {
    mobileNav.style.borderBottom = '1px solid #777777'
    arrow.style.transform = 'rotate(0deg)'
    ac.style.animation = 'slideout 1s forwards'
  }
})

function stripLSepTopTitle() {
  const topTitle = document.querySelectorAll('.top-title')
  if (!topTitle) {
    return
  }
  topTitle.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

function stripLSepArticleTitle() {
  const articleTitle = document.querySelectorAll('.article-title')
  if (!articleTitle) {
    return
  }
  articleTitle.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

function stripLSepEditorsTitle() {
  const editorsTitle = document.querySelectorAll('.editors-title')
  if (!editorsTitle) {
    return
  }
  editorsTitle.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

stripLSepEditorsTitle()
stripLSepArticleTitle()
stripLSepTopTitle()
